import { Fragment, useRef } from 'react';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import { RegistrationForm } from '../forms/registerForm';

export const RegisterFormDialog: React.FC<{
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  videoId: string;
  closeDialog: () => void;
  isLiveEvent: boolean;
}> = ({ open, setOpen, videoId, closeDialog, isLiveEvent }) => {
  const cancelButtonRef = useRef(null);

  const url = process.env.REACT_APP_MAIL_CHIMP_URL ?? '';

  return (
    <Transition show={open} as={Fragment}>
      <Dialog className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative transform overflow-hidden rounded-lg bg-[#0f1015] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-[#0f1015] px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <MailchimpSubscribe
                    url={url}
                    render={({ subscribe, status, message }) => (
                      <RegistrationForm
                        status={status}
                        message={message}
                        onValidated={(formData) => {
                          console.log(formData);
                          subscribe(formData);
                        }}
                        videoId={videoId}
                        closeDialog={closeDialog}
                        isLiveEvent={isLiveEvent}
                      />
                    )}
                  />
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
